import React, { useState } from 'react'
import { UiButton } from '../../../../_uiComponents/common/form/UiButton';
import Grid from '@mui/material/Grid';
import OtpInput from '../../../../_uiComponents/common/form/OtpInput';
import UiCheckbox from '../../../../_uiComponents/common/form/UiCheckBox';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import { Box } from '@mui/material';

function OtpVerification() {

    return (
        <>
            <Box component="div" sx={{ width: '100%' }}>
                <div className='sba-auth-top-heading'>
                    <h5>Please enter the OTP sent to your registered mobile & email</h5>
                </div>
                <OtpInput />
                <Grid container sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <Grid item xs={10} lg={8} sx={{ textAlign: 'left' }}>
                        <UiCheckbox label="Remember this device for 30 days" />
                    </Grid>
                    <Grid item xs={2} lg={4} 
                        className='sba-otp-checkbox'
                        sx={{ textAlign: 'left', display: 'flex', cursor: 'pointer' }}>
                        <Tooltip
                            title="If you check this, 
                        OTP verification won't be required while logging in for
                        the next 30 days."
                            placement="top"
                            arrow>
                            <InfoIcon className='sba-info-icon' />
                        </Tooltip>
                    </Grid>
                </Grid>

                <Grid container sx={{ mb: 6 }} >
                    <Grid alignItems="center" display="flex" item xs={6} sx={{ textAlign: 'left' }}>
                        <span variant="body2" className='sba-forgot-password-link' >
                            Resend OTP
                        </span>
                    </Grid>
                    <Grid item xs={6} sx={{ textAlign: 'right' }}>
                        <UiButton name="Verify" variant="contained" size="large" />
                    </Grid>
                </Grid>
                <p className='sba-login-bottom-support-mail'>Please reach <span>support@sherbetrewards.com </span>for further queries</p>
            </Box>
        </>
    )
}

export default OtpVerification

